var render, staticRenderFns
import script from "./SliderColor.vue?vue&type=script&lang=ts&"
export * from "./SliderColor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc2fa8",
  null
  
)

export default component.exports